// Copyright 2019 Ryan Zeigler
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
export function done(v) {
    return {
        _tag: "Done",
        value: v
    };
}
export function raise(e) {
    return {
        _tag: "Raise",
        error: e
    };
}
export function abort(a) {
    return {
        _tag: "Abort",
        abortedWith: a
    };
}
export const interrupt = {
    _tag: "Interrupt"
};
export const interruptWithError = (err) => err
    ? {
        _tag: "Interrupt",
        error: err
    }
    : {
        _tag: "Interrupt"
    };
export const interruptWithErrorAndOthers = (err, others) => others
    ? {
        _tag: "Interrupt",
        error: err,
        others
    }
    : {
        _tag: "Interrupt",
        error: err
    };
